import { useEffect } from 'react';
import outputMsgEngine from '../../../Widgets/OutputMsgWidget/Core/OutputMsgEngine.js';
import { DEBUG_LOGGING_ENABLED } from '../../../services/utils/debugMode.js';
import userSettingsEngine from '../../../controllers/UserSettings/UserSettingsEngine';

// Resolves display names for a connector's endpoints, '?' if missing/not found.
function getConnectorEndpointNames(connector, getShapeById) {
    if (!connector) {
        return { fromName: '?', toName: '?' };
    }
    const fromShape = getShapeById(connector.fromShapeId);
    const toShape = getShapeById(connector.toShapeId);
    return {
        fromName: fromShape?.caption?.text || fromShape?.name || '?',
        toName: toShape?.caption?.text || toShape?.name || '?',
    };
}

/**
 * Debug-hover-logging to OutputMsgWidget (cat 'Debug'), dev-only (DEBUG_LOGGING_ENABLED).
 * Format: id | name | action | geo — fixed columns, easier to scan than a running sentence.
 * @param {string|null} hoveredShapeId
 * @param {string|null} hoveredConnectorId
 * @param {object|null} hoveredGeo
 * @param {Array} connectors
 * @param {Function} getShapeById
 */
export default function useHoverDebugLogging(hoveredShapeId, hoveredConnectorId, hoveredGeo, connectors, getShapeById) {
    useEffect(
        function logHoveredForDebug() {
            if (!DEBUG_LOGGING_ENABLED || !userSettingsEngine.resolve('umlWorkspace.logHoverMessages')) return;

            if (hoveredGeo) {
                const connector = hoveredConnectorId ? connectors.find((c) => c.id === hoveredConnectorId) : null;
                const { fromName, toName } = getConnectorEndpointNames(connector, getShapeById);
                outputMsgEngine.addMsg(
                    'Debug',
                    'log',
                    `${(hoveredConnectorId || '').slice(0, 8)} | ${hoveredGeo.label} (${fromName} → ${toName}) | hover | x:${Math.round(hoveredGeo.x)} y:${Math.round(hoveredGeo.y)}`,
                );
            } else if (hoveredConnectorId) {
                const connector = connectors.find((c) => c.id === hoveredConnectorId);
                const { fromName, toName } = getConnectorEndpointNames(connector, getShapeById);
                outputMsgEngine.addMsg(
                    'Debug',
                    'log',
                    `${hoveredConnectorId.slice(0, 8)} | ${connector?.kind} | hover | ${fromName} → ${toName}`,
                );
            } else if (hoveredShapeId) {
                const shape = getShapeById(hoveredShapeId);
                if (!shape) return; // stale hoveredShapeId (shape removed since hover started)
                const name = shape?.caption?.text || shape?.name || '(no name)';
                outputMsgEngine.addMsg(
                    'Debug',
                    'log',
                    `${hoveredShapeId.slice(0, 8)} | ${name} | hover | x:${Math.round(shape.x)} y:${Math.round(shape.y)} w:${Math.round(shape.w)} h:${Math.round(shape.h)}`,
                );
            }
        },
        [hoveredShapeId, hoveredConnectorId, hoveredGeo, connectors, getShapeById],
    );
}
